import React, { useState, useEffect, useRef } from "react";
import { AUTH_STORAGE_KEY, SERVER_URL } from "../socket";
import useContacts from "../hooks/useContacts";
import useCallHistory from "../hooks/useCallHistory";
import {
  FiPhone, FiVideo, FiPhoneIncoming, FiPhoneMissed, FiPhoneOff,
  FiSearch, FiClock, FiUsers, FiMessageCircle, FiUserPlus,
  FiUserCheck, FiFilter, FiX, FiMoreVertical, FiMail
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";

function CallsPage({ setVideoCall, setVoiceCall ,onOpenComposeModal}) {
  const { contacts, fetchContacts } = useContacts();
  const { callHistory, loadingCalls, loadCallHistory, deleteCall, clearAllCalls } = useCallHistory();
    const navigate = useNavigate();

const [eContacts, setEContacts]         = useState([]);
const [loadingEContacts, setLoadingEContacts] = useState(false);
  const [tab, setTab]                     = useState("recents");
  const [contactSubTab, setContactSubTab] = useState("my");
  const [filter, setFilter]               = useState("all");
  const [search, setSearch]               = useState("");
  const [currentUser, setCurrentUser]     = useState(null);

  const [showAddContact, setShowAddContact] = useState(false);
  const [contactForm, setContactForm]       = useState({ name: "", emails: [] });

  const [domainUsers, setDomainUsers]     = useState([]);
  const [loadingDomain, setLoadingDomain] = useState(false);
  const [addingUser, setAddingUser]       = useState(null);

  // ── Filter panel state ─────────────────────────────────────────
  const [showFilter, setShowFilter]       = useState(false);
  const [activeFilters, setActiveFilters] = useState({
    onlineOnly:  false,
    hasEmail:    false,
    hasMobile:   false,
    savedOnly:   false,
    unsavedOnly: false,
  });
  const filterRef = useRef(null);

  const hasActiveFilter = Object.values(activeFilters).some(Boolean);

  /* ── close filter panel on outside click ─────────────────────── */
  useEffect(() => {
    const handler = (e) => {
      if (filterRef.current && !filterRef.current.contains(e.target)) {
        setShowFilter(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  /* ── init ───────────────────────────────────────────────────── */
  useEffect(() => {
    loadCallHistory();
    try {
      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : null;
      setCurrentUser(parsed?.user?.email?.toLowerCase() || null);
    } catch { /**/ }
  }, []);

  useEffect(() => {
    if (contactSubTab === "domain" || contactSubTab === "all") loadDomainUsers();
  }, [contactSubTab]);

  useEffect(() => {
    const handler = () => fetchContacts?.();
    window.addEventListener("contacts-refresh", handler);
    return () => window.removeEventListener("contacts-refresh", handler);
  }, []);
useEffect(() => {
  if (contactSubTab === "econtact") loadEContacts();
}, [contactSubTab]);

const loadEContacts = async () => {
  setLoadingEContacts(true);
  try {
    const raw    = localStorage.getItem(AUTH_STORAGE_KEY);
    const parsed = JSON.parse(raw);
    const res    = await fetch(`${SERVER_URL}/api/users/econtacts`, {
      headers: { Authorization: `Bearer ${parsed.token}` }
    });
    const data = await res.json();
    setEContacts(data.users || []);
  } catch { /**/ }
  finally { setLoadingEContacts(false); }
};
  /* ── loaders ────────────────────────────────────────────────── */
  const loadDomainUsers = async () => {
    setLoadingDomain(true);
    try {
      const raw    = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = JSON.parse(raw);
      const res    = await fetch(`${SERVER_URL}/api/users/same-client`, {
        headers: { Authorization: `Bearer ${parsed.token}` }
      });
      const data = await res.json();
      setDomainUsers(data.users || []);
    } catch { /**/ }
    finally { setLoadingDomain(false); }
  };

  /* ── handlers ───────────────────────────────────────────────── */
  const handleChat = (contact) => {
    navigate("/kmail/Krivachat", {
      state: { email: contact.emails?.[0] || contact.userId, name: contact.name || contact.fullName }
    });
  };

  const handleAddContact = async (e) => {
    e.preventDefault();
    if (!contactForm.emails[0]) return;
    const raw    = localStorage.getItem(AUTH_STORAGE_KEY);
    const parsed = JSON.parse(raw);
    await fetch(`${SERVER_URL}/api/contacts`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${parsed.token}` },
      body: JSON.stringify({ contactId: contactForm.emails[0], alias: contactForm.name }),
    });
    alert("Contact Added ✅");
    setShowAddContact(false);
    setContactForm({ name: "", emails: [] });
    fetchContacts?.();
  };

  const handleQuickAdd = async (user) => {
    setAddingUser(user.userId);
    try {
      const raw    = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = JSON.parse(raw);
      await fetch(`${SERVER_URL}/api/contacts`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${parsed.token}` },
        body: JSON.stringify({ contactId: user.userId, alias: user.fullName }),
      });
      window.dispatchEvent(new Event("contacts-refresh"));
    } catch { alert("Failed to add"); }
    finally { setAddingUser(null); }
  };

  const handleRemoveContact = async (email) => {
    if (!window.confirm("Remove this contact?")) return;
    try {
      const raw    = localStorage.getItem(AUTH_STORAGE_KEY);
      const parsed = JSON.parse(raw);
      await fetch(`${SERVER_URL}/api/contacts/${email}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${parsed.token}` },
      });
      window.dispatchEvent(new Event("contacts-refresh"));
    } catch { alert("Failed to remove contact"); }
  };

  const makeVoiceCall = (email) => {
    const e = typeof email === "string" ? email : email?.emails?.[0] || email?.userId;
    if (!e || !setVoiceCall) return;
    setVoiceCall({ remoteUser: e, isCaller: true, type: "voice" });
  };

  const makeVideoCall = (email) => {
    const e = typeof email === "string" ? email : email?.emails?.[0] || email?.userId;
    if (!e || !setVideoCall) return;
    setVideoCall({ remoteUser: e, isCaller: true, type: "video" });
  };

  const callBack = (call) => {
    const other = call.caller === currentUser ? call.receiver : call.caller;
    if (call.type === "video") makeVideoCall(other);
    else                       makeVoiceCall(other);
  };

  const clearAllFilters = () => {
    setActiveFilters({ onlineOnly: false, hasEmail: false, hasMobile: false, savedOnly: false, unsavedOnly: false });
  };

  /* ── helpers ────────────────────────────────────────────────── */
  const isInMyContacts = (email) => contacts.some(c => c.emails?.[0] === email);

  const getContactName = (email) => {
    const c = contacts.find(c => c.emails?.[0] === email);
    return c?.name || email?.split("@")[0] || "Unknown";
  };

  const getAvatar = (email) => {
    const c = contacts.find(c => c.emails?.[0] === email);
    return c?.profileImageUrl ? `${SERVER_URL}${c.profileImageUrl}` : null;
  };

  const formatDuration = (secs) => {
    if (!secs || secs < 1) return "";
    const m = Math.floor(secs / 60), s = secs % 60;
    return m > 0 ? `${m}m ${s}s` : `${s}s`;
  };

  const formatCallTime = (ts) => {
    if (!ts) return "";
    const d = new Date(ts), now = new Date();
    const yesterday = new Date(now); yesterday.setDate(now.getDate() - 1);
    if (d.toDateString() === now.toDateString())       return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    if (d.toDateString() === yesterday.toDateString()) return "Yesterday";
    return d.toLocaleDateString([], { day: "numeric", month: "short" });
  };

  /* ── apply filters to any contact list ───────────────────────── */
  const applyFilters = (list) => {
    return list.filter(c => {
      const email    = c.emails?.[0] || c.userId || "";
      const name     = (c.name || c.fullName || "").toLowerCase();
      const mobile   = c.mobileNumber || "";
      const inSearch = !search || name.includes(search.toLowerCase()) || email.toLowerCase().includes(search.toLowerCase());

      if (!inSearch) return false;
      if (activeFilters.hasEmail    && !email)                    return false;
      if (activeFilters.hasMobile   && !mobile)                   return false;
      if (activeFilters.savedOnly   && !isInMyContacts(email))    return false;
      if (activeFilters.unsavedOnly && isInMyContacts(email))     return false;
      return true;
    });
  };

  /* ── filtered lists ─────────────────────────────────────────── */
  const filteredHistory = callHistory.filter(c => {
    const other = c.caller === currentUser ? c.receiver : c.caller;
    const name  = (c.groupName || getContactName(other)).toLowerCase();
    if (search && !name.includes(search.toLowerCase())) return false;
    if (filter === "missed") return c.status === "missed";
    if (filter === "video")  return c.type === "video";
    if (filter === "voice")  return c.type === "voice";
    return true;
  });

  const myEmails = new Set(contacts.map(c => c.emails?.[0]));

  const allContactsList = [
    ...contacts,
    ...domainUsers
      .filter(u => !myEmails.has(u.userId))
      .map(u => ({ id: u.userId, name: u.fullName, emails: [u.userId], profileImageUrl: u.profileImageUrl, mobileNumber: u.mobileNumber }))
  ];

  const filteredMyContacts   = applyFilters(contacts);
  const filteredAllContacts  = applyFilters(allContactsList);
  const filteredDomainUsers  = applyFilters(
    domainUsers.map(u => ({ ...u, emails: [u.userId], name: u.fullName }))
  );

  /* ── sub-components ─────────────────────────────────────────── */
  const Avatar = ({ email, src, name, size = 46 }) => {
    const imgSrc  = src || getAvatar(email);
    const initial = (name || email || "?")[0].toUpperCase();
    return imgSrc ? (
      <img src={imgSrc.startsWith("http") ? imgSrc : `${SERVER_URL}${imgSrc}`}
        alt={name}
        style={{ width: size, height: size, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />
    ) : (
      <div style={{
        width: size, height: size, borderRadius: "50%", flexShrink: 0,
        background: "linear-gradient(135deg,#f57011,#ef4444)",
        display: "flex", alignItems: "center", justifyContent: "center",
        color: "#fff", fontWeight: 700, fontSize: size * 0.4,
      }}>
        {initial}
      </div>
    );
  };

  const CallIcon = ({ call }) => {
    const isCaller = call.caller === currentUser;
    if (call.status === "missed") return <FiPhoneMissed size={15} color="#ef4444" />;
    if (isCaller) return call.type === "video"
      ? <FiVideo size={15} color="#22c55e" />
      : <FiPhone size={15} color="#22c55e" />;
    return <FiPhoneIncoming size={15} color="#3b82f6" />;
  };

  const ContactRow = ({ name, email, profileImageUrl, mobileNumber, showRemove = false, showQuickAdd = false, domainUser = null, userId = null }) => {
    const [openActions, setOpenActions] = useState(false);
    const actionMenuStyle = {
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: 10,
      padding: "10px 12px",
      color: "#e2e8f0",
      background: "transparent",
      border: "none",
      textAlign: "left",
      cursor: "pointer",
      fontSize: 13,
    };

    const handleRowClick = () => {
      if (userId) {
        navigate(`/${userId}`);
      }
    };

    return (
      <div style={{
        display: "flex", alignItems: "center", gap: 12,
        padding: "12px 16px",
        borderBottom: "1px solid rgba(255,255,255,0.05)",
        cursor: userId ? "pointer" : "default",
      }}
      onClick={handleRowClick}
      >
        <Avatar email={email} src={profileImageUrl} name={name} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: 14, color: "var(--text-primary,#f1f5f9)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {name}
            {isInMyContacts(email) && (
              <span style={{ marginLeft: 6, fontSize: 10, color: "#22c55e", fontWeight: 500 }}>● saved</span>
            )}
          </div>
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {email}
          </div>
          {mobileNumber && (
            <div style={{ fontSize: 11, color: "#475569", marginTop: 1 }}>📱 {mobileNumber}</div>
          )}
        </div>
        <div style={{ position: "relative", display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
          {/* Quick Action Buttons */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              makeVoiceCall(email);
            }}
            title="Voice Call"
            style={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              border: "none",
              background: "rgba(34,197,94,0.15)",
              color: "#22c55e",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s",
              fontSize: 16,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(34,197,94,0.25)";
              e.currentTarget.style.transform = "scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(34,197,94,0.15)";
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <FiPhone size={16} />
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              makeVideoCall(email);
            }}
            title="Video Call"
            style={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              border: "none",
              background: "rgba(59,130,246,0.15)",
              color: "#3b82f6",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s",
              fontSize: 16,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(59,130,246,0.25)";
              e.currentTarget.style.transform = "scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(59,130,246,0.15)";
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <FiVideo size={16} />
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              setOpenActions(prev => !prev);
            }}
            title="More Actions"
            style={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              border: "none",
              background: "rgba(148,163,184,0.12)",
              color: "#cbd5e1",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FiMoreVertical size={18} />
          </button>

          {openActions && (
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                position: "absolute",
                right: 0,
                top: 44,
                zIndex: 10,
                minWidth: 180,
                background: "#0f172a",
                border: "1px solid rgba(148,163,184,0.15)",
                borderRadius: 10,
                boxShadow: "0 12px 30px rgba(15,23,42,0.35)",
                overflow: "hidden",
              }}
            >
              <button
                type="button"
                onClick={() => {
                  handleChat({ emails: [email], name, userId: email });
                  setOpenActions(false);
                }}
                style={actionMenuStyle}
              >
                <FiMessageCircle size={14} />
                <span>Chat</span>
              </button>
              <button
                type="button"
                onClick={() => {
  onOpenComposeModal?.(email);
  setOpenActions(false);
}}
                style={actionMenuStyle}
              >
                <FiMail size={14} />
                <span>Email</span>
              </button>
              <button
                type="button"
                onClick={() => {
                  makeVoiceCall(email);
                  setOpenActions(false);
                }}
                style={actionMenuStyle}
              >
                <FiPhone size={14} />
                <span>Voice call</span>
              </button>
              <button
                type="button"
                onClick={() => {
                  makeVideoCall(email);
                  setOpenActions(false);
                }}
                style={actionMenuStyle}
              >
                <FiVideo size={14} />
                <span>Video call</span>
              </button>
              {showQuickAdd && !isInMyContacts(email) && (
                <button
                  type="button"
                  onClick={() => {
                    handleQuickAdd(domainUser || { userId: email, fullName: name });
                    setOpenActions(false);
                  }}
                  style={actionMenuStyle}
                >
                  <FiUserPlus size={14} />
                  <span>Save contact</span>
                </button>
              )}
              {showQuickAdd && isInMyContacts(email) && (
                <button type="button" style={actionMenuStyle} disabled>
                  <FiUserCheck size={14} />
                  <span>Saved</span>
                </button>
              )}
              {showRemove && (
                <button
                  type="button"
                  onClick={() => {
                    handleRemoveContact(email);
                    setOpenActions(false);
                  }}
                  style={actionMenuStyle}
                >
                  <i className="fa-solid fa-trash" style={{ fontSize: 12 }} />
                  <span>Remove contact</span>
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  /* ══════════════════════════════════════════════════════════════ */
  return (
    <div style={{
      display: "flex", flexDirection: "column",
      height: "calc(100dvh - 60px)",
      background: "var(--bg-primary, #050505)",
      color: "var(--text-primary, #f1f5f9)",
      overflowX: "hidden",
    }}>

      {/* ── Header ─────────────────────────────────────────────── */}
      <div style={{
        position: "sticky", top: 0, zIndex: 20,
        background: "var(--bg-primary, #050505)",
        padding: "14px 16px 0",
        borderBottom: "1px solid rgba(255,255,255,0.07)",
      }}>
          <div className="mail-brand-content">
          <img src="/TimeEdgeIcon.png" alt="TimeEdge Icon" className="mail-brand-icon mobilecsslogo" />
         
        

             <h3 className="app-title1">
              
  Kriva <span className="chat-blue">Bharat Call</span>
</h3>
</div>

        {/* ── Search + Filter + Add ─────────────────────────────── */}
        <div style={{ position: "relative", marginBottom: 12 }} ref={filterRef}>
          <div style={{
            display: "flex", alignItems: "center", gap: 8,
            background: "var(--bg-input, #18263e)",
            borderRadius: 10, padding: "8px 12px",
          }}>
            <FiSearch size={15} color="#64748b" />
            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search name or email..."
              style={{
                flex: 1, border: "none", outline: "none",
                background: "transparent",
                color: "var(--text-primary, #f1f5f9)", fontSize: 14,
              }}
            />
            {search && (
              <button onClick={() => setSearch("")}
                style={{ background: "none", border: "none", color: "#64748b", cursor: "pointer", fontSize: 16, padding: 0 }}>
                ×
              </button>
            )}

            {/* Filter toggle */}
            <button
              onClick={() => setShowFilter(p => !p)}
              title="Filter contacts"
              style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: 30, height: 30, borderRadius: 8,
                border: "none", cursor: "pointer",
                background: hasActiveFilter ? "rgba(245,112,17,0.25)" : "rgba(255,255,255,0.07)",
                color: hasActiveFilter ? "#f57011" : "#64748b",
                position: "relative", flexShrink: 0,
              }}>
              <FiFilter size={14} />
              {hasActiveFilter && (
                <span style={{
                  position: "absolute", top: -4, right: -4,
                  width: 8, height: 8, borderRadius: "50%",
                  background: "#f57011",
                }} />
              )}
            </button>

            {/* Add contact */}
            <button
              onClick={() => setShowAddContact(true)}
              title="Add contact"
              style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: 30, height: 30, borderRadius: 8,
                border: "none", cursor: "pointer",
                background: "rgba(255,255,255,0.07)", color: "#94a3b8",
                flexShrink: 0,
              }}>
              <FiUserPlus size={14} />
            </button>
          </div>

          {/* ── Filter Dropdown Panel ──────────────────────────── */}
          {showFilter && (
            <div style={{
              position: "absolute", top: "calc(100% + 6px)",
              left: 0, right: 0, zIndex: 99,
              background: "#0f172a",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: 12,
              padding: "14px 16px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
            }}>
              {/* Header */}
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: "#f1f5f9" }}>
                  Filter Contacts
                </span>
                {hasActiveFilter && (
                  <button onClick={clearAllFilters}
                    style={{
                      background: "none", border: "none",
                      color: "#ef4444", fontSize: 11,
                      fontWeight: 600, cursor: "pointer",
                    }}>
                    Clear all
                  </button>
                )}
              </div>

              {/* Filter options */}
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                {[
                  { key: "savedOnly",   label: "Saved contacts only",   icon: "⭐" },
                  { key: "unsavedOnly", label: "Unsaved contacts only",  icon: "👤" },
                  { key: "hasMobile",   label: "Has mobile number",      icon: "📱" },
                  { key: "hasEmail",    label: "Has email address",      icon: "📧" },
                ].map(({ key, label, icon }) => {
                  // mutually exclusive: savedOnly ↔ unsavedOnly
                  const isDisabled =
                    (key === "savedOnly"   && activeFilters.unsavedOnly) ||
                    (key === "unsavedOnly" && activeFilters.savedOnly);

                  return (
                    <label key={key}
                      style={{
                        display: "flex", alignItems: "center", gap: 10,
                        padding: "9px 10px", borderRadius: 8,
                        background: activeFilters[key] ? "rgba(245,112,17,0.12)" : "transparent",
                        border: `1px solid ${activeFilters[key] ? "rgba(245,112,17,0.3)" : "transparent"}`,
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        opacity: isDisabled ? 0.4 : 1,
                        transition: "all 0.15s",
                      }}>
                      <input
                        type="checkbox"
                        checked={activeFilters[key]}
                        disabled={isDisabled}
                        onChange={() =>
                          setActiveFilters(prev => ({ ...prev, [key]: !prev[key] }))
                        }
                        style={{ accentColor: "#f57011", width: 15, height: 15 }}
                      />
                      <span style={{ fontSize: 13, color: "#cbd5e1" }}>{icon} {label}</span>
                    </label>
                  );
                })}
              </div>

              {/* Active filter tags */}
              {hasActiveFilter && (
                <div style={{ marginTop: 12, display: "flex", flexWrap: "wrap", gap: 6 }}>
                  {Object.entries(activeFilters)
                    .filter(([, v]) => v)
                    .map(([k]) => {
                      const labels = {
                        savedOnly: "Saved only", unsavedOnly: "Unsaved only",
                        hasMobile: "Has mobile", hasEmail: "Has email",
                      };
                      return (
                        <span key={k} style={{
                          display: "inline-flex", alignItems: "center", gap: 4,
                          background: "rgba(245,112,17,0.2)", color: "#f57011",
                          borderRadius: 20, padding: "3px 10px", fontSize: 11, fontWeight: 600,
                        }}>
                          {labels[k]}
                          <FiX size={10} style={{ cursor: "pointer" }}
                            onClick={() => setActiveFilters(prev => ({ ...prev, [k]: false }))} />
                        </span>
                      );
                    })}
                </div>
              )}
            </div>
          )}
        </div>

        {/* ── Main Tabs ───────────────────────────────────────── */}
        <div style={{ display: "flex" }}>
          {[
            { key: "recents",  label: "Recents",  icon: <FiClock size={13} /> },
            { key: "contacts", label: "Contacts", icon: <FiUsers size={13} /> },
          ].map(({ key, label, icon }) => (
            <button key={key} onClick={() => setTab(key)}
              style={{
                flex: 1, padding: "10px 0",
                background: "none", border: "none",
                borderBottom: tab === key ? "2px solid #f57011" : "2px solid transparent",
                color: tab === key ? "#f57011" : "#64748b",
                fontWeight: tab === key ? 700 : 500,
                fontSize: 13, cursor: "pointer",
                display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
              }}>
              {icon} {label}
            </button>
          ))}
        </div>

        {/* ── Contact Sub-Tabs ─────────────────────────────────── */}
        {tab === "contacts" && (
          <div style={{ marginTop: 12, display: "flex", borderTop: "1px solid rgba(255,255,255,0.05)" }}>
            {[
              { key: "all",    label: "All" },
              { key: "my",     label: "My Contacts" },
              { key: "domain", label: "My Domain" },
              { key: "econtact", label: "E Contact" }, 
            ].map(({ key, label }) => (
              <button key={key} onClick={() => setContactSubTab(key)}
                style={{
                  flex: 1, padding: "9px 0",
                  background: "none", border: "none",
                  borderBottom: contactSubTab === key ? "2px solid #3b82f6" : "2px solid transparent",
                  color: contactSubTab === key ? "#3b82f6" : "#64748b",
                  fontWeight: contactSubTab === key ? 700 : 500,
                  fontSize: 12, cursor: "pointer",
                }}>
                {label}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* ── Add Contact Modal ────────────────────────────────────── */}
      {showAddContact && (
        <div className="contacts-form-overlay">
          <div className="contacts-form">
            <h3 className="form-title">Add New Contact</h3>
            <form onSubmit={handleAddContact} className="form-body">
              <div className="input-group">
                <input type="text" placeholder=" " value={contactForm.name}
                  onChange={e => setContactForm(p => ({ ...p, name: e.target.value }))} />
                <label>Contact Name</label>
              </div>
              <div className="input-group">
                <input type="text" placeholder=" " value={contactForm.emails[0] || ""}
                  onChange={e => setContactForm(p => ({ ...p, emails: [e.target.value] }))} />
                <label>Email</label>
              </div>
              <div className="form-buttons">
                <button type="submit" className="btn-primary">Add Contact</button>
                <button type="button" className="btn-secondary" onClick={() => setShowAddContact(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── Recents Tab ─────────────────────────────────────────── */}
      {tab === "recents" && (
        <div style={{ flex: 1, overflowY: "auto" }}>
          <div style={{
            display: "flex", gap: 6, padding: "10px 14px",
            overflowX: "auto", scrollbarWidth: "none",
            position: "sticky", top: 0, zIndex: 10,
            background: "var(--bg-primary, #050505)",
          }}>
            {["all", "missed", "voice", "video"].map(f => (
              <button key={f} onClick={() => setFilter(f)}
                style={{
                  border: `1px solid ${filter === f ? "#f57011" : "rgba(255,255,255,0.12)"}`,
                  borderRadius: 20, padding: "4px 12px",
                  background: filter === f ? "rgba(245,112,17,0.15)" : "transparent",
                  color: filter === f ? "#f57011" : "#94a3b8",
                  fontSize: 12, fontWeight: 600, cursor: "pointer",
                  whiteSpace: "nowrap", flexShrink: 0,
                }}>
                {f === "all" ? "All" : f.charAt(0).toUpperCase() + f.slice(1)}
              </button>
            ))}
            {callHistory.length > 0 && (
              <button onClick={() => window.confirm("Clear all?") && clearAllCalls()}
                style={{
                  marginLeft: "auto", border: "1px solid #fecaca",
                  borderRadius: 20, padding: "4px 12px",
                  background: "transparent", color: "#ef4444",
                  fontSize: 12, fontWeight: 600, cursor: "pointer",
                }}>
                Clear All
              </button>
            )}
          </div>

          {loadingCalls && <LoadingSpinner />}

          {!loadingCalls && filteredHistory.length === 0 && (
            <EmptyState icon={<FiPhoneOff size={44} color="#334155" />}
              title="No call history"
              sub={filter !== "all" ? "Try changing the filter" : "Your recent calls will appear here"} />
          )}

          {filteredHistory.map(call => {
            const isCaller = call.caller === currentUser;
            const other    = isCaller ? call.receiver : call.caller;
            const name     = call.groupName || getContactName(other);
            const isMissed = call.status === "missed";
            return (
              <div key={call.id} style={{
                display: "flex", alignItems: "center", gap: 12,
                padding: "12px 16px",
                borderBottom: "1px solid rgba(255,255,255,0.05)",
              }}>
                <Avatar email={other} name={name} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 3 }}>
                    <CallIcon call={call} />
                    <span style={{
                      fontWeight: 600, fontSize: 14,
                      color: isMissed ? "#ef4444" : "var(--text-primary,#f1f5f9)",
                      overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                    }}>
                      {name}
                    </span>
                  </div>
                  <div style={{ display: "flex", gap: 6, fontSize: 11, color: "#64748b" }}>
                    <span>{isCaller ? "Outgoing" : "Incoming"}</span>
                    <span>·</span>
                    <span>{call.type === "video" ? "📹 Video" : "📞 Voice"}</span>
                    {call.duration > 0 && <><span>·</span><span>{formatDuration(call.duration)}</span></>}
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 8, flexShrink: 0 }}>
                  <span style={{ fontSize: 11, color: "#64748b" }}>
                    {formatCallTime(call.createdAt || call.startTime)}
                  </span>
                  <div style={{ display: "flex", gap: 6 }}>
                    <button onClick={() => callBack(call)} style={btnStyle("rgba(34,197,94,0.15)", "#22c55e")}>
                      {call.type === "video" ? <FiVideo size={14} /> : <FiPhone size={14} />}
                    </button>
                    <button onClick={() => deleteCall(call.id)} style={btnStyle("rgba(239,68,68,0.12)", "#ef4444")}>
                      <i className="fa-solid fa-trash" style={{ fontSize: 11 }} />
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ── Contacts Tab ────────────────────────────────────────── */}
      {tab === "contacts" && (
        <div style={{ flex: 1, overflowY: "auto" }}>

          {/* All */}
          {contactSubTab === "all" && (
            <>
              <SubTabHeader count={filteredAllContacts.length} label="contacts total" />
              {filteredAllContacts.length === 0
                ? <EmptyState icon={<FiUsers size={40} color="#334155" />} title="No contacts found" />
                : filteredAllContacts.map(c => (
                  <ContactRow key={c.emails?.[0]}
                    name={c.name} email={c.emails?.[0]}
                    profileImageUrl={c.profileImageUrl}
                    mobileNumber={c.mobileNumber}
                    showRemove={isInMyContacts(c.emails?.[0])}
                    showQuickAdd={!isInMyContacts(c.emails?.[0])}
                    domainUser={{ userId: c.emails?.[0], fullName: c.name }}
                    userId={c.emails?.[0]}
                  />
                ))
              }
            </>
          )}

          {/* My Contacts */}
          {contactSubTab === "my" && (
            <>
              <SubTabHeader count={filteredMyContacts.length} label="saved contacts"
                action={
                  <button onClick={() => setShowAddContact(true)}
                    style={{
                      display: "flex", alignItems: "center", gap: 6,
                      background: "rgba(37,99,235,0.15)", color: "#60a5fa",
                      border: "1px solid rgba(37,99,235,0.3)",
                      borderRadius: 20, padding: "5px 12px",
                      fontSize: 12, fontWeight: 600, cursor: "pointer",
                    }}>
                    <FiUserPlus size={13} /> Add Contact
                  </button>
                }
              />
              {filteredMyContacts.length === 0
                ? <EmptyState icon={<FiUsers size={40} color="#334155" />}
                    title="No saved contacts"
                    sub='Tap "Add Contact" to save someone' />
                : filteredMyContacts.map(c => (
                  <ContactRow key={c.emails?.[0]}
                    name={c.name} email={c.emails?.[0]}
                    profileImageUrl={c.profileImageUrl}
                    mobileNumber={c.mobileNumber}
                    showRemove={true}
                    userId={c.emails?.[0]}
                  />
                ))
              }
            </>
          )}

          {/* My Domain */}
          {contactSubTab === "domain" && (
            <>
              <SubTabHeader count={filteredDomainUsers.length} label="people in your organisation" />
              {loadingDomain
                ? <LoadingSpinner />
                : filteredDomainUsers.length === 0
                  ? <EmptyState icon={<FiUsers size={40} color="#334155" />} title="No users found in your domain" />
                  : filteredDomainUsers.map(u => (
                    <ContactRow key={u.userId || u.emails?.[0]}
                      name={u.fullName || u.name || (u.userId || u.emails?.[0] || "").split("@")[0]}
                      email={u.userId || u.emails?.[0]}
                      profileImageUrl={u.profileImageUrl}
                      mobileNumber={u.mobileNumber}
                      showQuickAdd={true}
                      domainUser={u}
                      userId={u.userId}
                    />
                  ))
              }
            </>
          )}

          {/* ── E Contact sub-tab ── */}
          {contactSubTab === "econtact" && (
            <>
              {/* Header count */}
              <SubTabHeader
                count={eContacts.filter(u => {
                  // only count users that have at least one public service
                  if (!u.services || u.services.length === 0) return false;
                  return true;
                }).length}
                label="public contacts"
              />

              {loadingEContacts
                ? <LoadingSpinner />
                : (() => {
                    const filtered = eContacts.filter(u => {
                      // only include users with at least one public service
                      if (!u.services || u.services.length === 0) return false;
                      return true;
                    });

                    if (!filtered.length) {
                      return <EmptyState
                        icon={<FiUsers size={40} color="#334155" />}
                        title="No contacts found"
                        sub="Try a different search"
                      />;
                    }

                return filtered.map(u => (
  <EContactRow
    key={u.userId}
    user={u}
    isInMyContacts={isInMyContacts(u.userId)}
    addingUser={addingUser}
    onAdd={() => handleQuickAdd({ userId: u.userId, fullName: u.fullName })}
    onChat={() => handleChat({ emails: [u.userId], name: u.fullName, userId: u.userId })}
    onVoice={() => makeVoiceCall(u.userId)}
    onVideo={() => makeVideoCall(u.userId)}
    onEmail={() => onOpenComposeModal?.(u.userId)}
  />
));
                  })()
              }
            </>
          )}
        </div>
      )}
    </div>
  );
}
const EContactRow = ({ user, isInMyContacts: saved, addingUser, onAdd, onChat, onVoice, onVideo, onEmail }) => {
  const [expanded, setExpanded] = useState(false);
  const [openActions, setOpenActions] = useState(false);
  const hasServices = user.services?.length > 0;
  const navigate = useNavigate();

  
  function slugifyBusinessPath(value) {
  return String(value || "business")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "business";
}

const handleRowClick = () => {
  if (!hasServices) return;

  const service = user.services?.[0];
  if (!service?.id) return;

  const businessSlug = slugifyBusinessPath(
    service.businessName || user.fullName
  );

  navigate(`/${businessSlug}-${service.id}`);
};

  return (
    <div style={{
      borderBottom: "1px solid rgba(255,255,255,0.05)",
      transition: "background 0.15s",
    }}>
      {/* Main row */}
      <div style={{
        display: "flex", alignItems: "center", gap: 12,
        padding: "12px 16px",
        cursor: hasServices ? "pointer" : "default",
      }}
        onClick={handleRowClick}
      >
        {/* Avatar */}
        <div style={{ position: "relative", flexShrink: 0 }}>
          {user.profileImageUrl ? (
            <img
              src={`${SERVER_URL}${user.profileImageUrl}`}
              alt={user.fullName}
              style={{ width: 46, height: 46, borderRadius: "50%", objectFit: "cover" }}
            />
          ) : (
            <div style={{
              width: 46, height: 46, borderRadius: "50%",
              background: "linear-gradient(135deg,#6366f1,#3b82f6)",
              display: "flex", alignItems: "center", justifyContent: "center",
              color: "#fff", fontWeight: 700, fontSize: 18,
            }}>
              {user.fullName[0]?.toUpperCase()}
            </div>
          )}
          {hasServices && (
            <span style={{
              position: "absolute", bottom: -2, right: -2,
              background: "#f57011", borderRadius: "50%",
              width: 16, height: 16,
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 9, color: "#fff", fontWeight: 700,
              border: "2px solid var(--bg-primary,#050505)"
            }}>
              {user.services.length}
            </span>
          )}
        </div>

        {/* Info */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
            <span style={{
              fontWeight: 600, fontSize: 14,
              color: "var(--text-primary,#f1f5f9)",
              overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
              maxWidth: 140,
            }}>
              {user.fullName}
            </span>
            {saved && (
              <span style={{
                fontSize: 10, color: "#22c55e", fontWeight: 600,
                background: "rgba(34,197,94,0.1)",
                borderRadius: 10, padding: "1px 6px",
              }}>
                ✓ saved
              </span>
            )}
          </div>

          {/* Email */}
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            📧 {user.userId}
          </div>

          {/* Service tags */}
          {hasServices && (
            <div style={{ display: "flex", gap: 4, marginTop: 4, flexWrap: "wrap" }}>
              {user.services.slice(0, 2).map((s, i) => (
                <span key={i} style={{
                  fontSize: 10, fontWeight: 600,
                  background: "rgba(245,112,17,0.15)",
                  color: "#f97316",
                  borderRadius: 10, padding: "2px 7px",
                  border: "1px solid rgba(245,112,17,0.25)",
                }}>
                  🔧 {s.category}
                </span>
              ))}
              {user.services.length > 2 && (
                <span style={{
                  fontSize: 10, color: "#64748b",
                  borderRadius: 10, padding: "2px 6px",
                  background: "rgba(255,255,255,0.05)",
                }}>
                  +{user.services.length - 2} more
                </span>
              )}
            </div>
          )}
        </div>

        {/* Action menu (matches ContactRow) */}
        <div style={{ position: "relative", display: "flex", alignItems: "center", flexShrink: 0 }} onClick={e => e.stopPropagation()}>
          <button
            onClick={(e) => { e.stopPropagation(); setExpanded(false); setOpenActions(prev => !prev); }}
            title="Actions"
            style={{
              width: 36, height: 36, borderRadius: "50%", border: "none",
              background: "rgba(148,163,184,0.12)", color: "#cbd5e1",
              cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
            }}
          >
            <FiMoreVertical size={18} />
          </button>

          {openActions && (
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                position: "absolute",
                right: 0,
                top: 44,
                zIndex: 10,
                minWidth: 180,
                background: "#0f172a",
                border: "1px solid rgba(148,163,184,0.15)",
                borderRadius: 10,
                boxShadow: "0 12px 30px rgba(15,23,42,0.35)",
                overflow: "hidden",
              }}
            >
              {(() => {
                const actionMenuStyle = {
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "10px 12px",
                  color: "#e2e8f0",
                  background: "transparent",
                  border: "none",
                  textAlign: "left",
                  cursor: "pointer",
                  fontSize: 13,
                };
                return (
                  <>
                    <button type="button" onClick={() => { onChat(); setOpenActions(false); }} style={actionMenuStyle}>
                      <FiMessageCircle size={14} />
                      <span>Chat</span>
                    </button>
                    <button type="button" onClick={() => { onEmail?.(); setOpenActions(false); }} style={actionMenuStyle}>
                      <FiMail size={14} />
                      <span>Email</span>
                    </button>
                    <button type="button" onClick={() => { onVoice(); setOpenActions(false); }} style={actionMenuStyle}>
                      <FiPhone size={14} />
                      <span>Voice call</span>
                    </button>
                    <button type="button" onClick={() => { onVideo(); setOpenActions(false); }} style={actionMenuStyle}>
                      <FiVideo size={14} />
                      <span>Video call</span>
                    </button>
                    {!saved ? (
                      <button type="button" onClick={() => { onAdd(); setOpenActions(false); }} style={actionMenuStyle}>
                        <FiUserPlus size={14} />
                        <span>Save contact</span>
                      </button>
                    ) : (
                      <button type="button" style={actionMenuStyle} disabled>
                        <FiUserCheck size={14} />
                        <span>Saved</span>
                      </button>
                    )}
                  </>
                );
              })()}
            </div>
          )}
        </div>
      </div>

      {/* ── Expanded service details ── */}
      {expanded && hasServices && (
        <div style={{
          margin: "0 16px 12px 74px",
          borderRadius: 10,
          overflow: "hidden",
          border: "1px solid rgba(255,255,255,0.07)",
        }}>
          {/* Table header */}
          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1.5fr 1fr",
            padding: "7px 12px",
            background: "rgba(255,255,255,0.04)",
            borderBottom: "1px solid rgba(255,255,255,0.07)",
          }}>
            {["Service", "Description", "Phone"].map(h => (
              <span key={h} style={{ fontSize: 10, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                {h}
              </span>
            ))}
          </div>

          {/* Table rows */}
          {user.services.map((s, i) => (
            <div key={i} style={{
              display: "grid",
              gridTemplateColumns: "1fr 1.5fr 1fr",
              padding: "9px 12px",
              borderBottom: i < user.services.length - 1 ? "1px solid rgba(255,255,255,0.04)" : "none",
              background: i % 2 === 0 ? "transparent" : "rgba(255,255,255,0.02)",
            }}>
              <span style={{
                fontSize: 12, fontWeight: 600, color: "#f97316",
                overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
              }}>
                🔧 {s.category}
              </span>
              <span style={{
                fontSize: 12, color: "#cbd5e1",
                overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                paddingRight: 8,
              }}>
                {s.description || "—"}
              </span>
              <span style={{ fontSize: 12, color: "#94a3b8" }}>
                {s.phone ? `📞 ${s.phone}` : "—"}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
/* ── Shared helpers ──────────────────────────────────────────────── */
const btnStyle = (bg, color) => ({
  width: 34, height: 34, borderRadius: "50%",
  border: "none", cursor: "pointer",
  background: bg, color,
  display: "flex", alignItems: "center", justifyContent: "center",
  flexShrink: 0,
});

const EmptyState = ({ icon, title, sub }) => (
  <div style={{
    display: "flex", flexDirection: "column",
    alignItems: "center", justifyContent: "center",
    padding: "60px 20px", gap: 10, color: "#475569",
  }}>
    {icon}
    <p style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>{title}</p>
    {sub && <p style={{ margin: 0, fontSize: 13, color: "#64748b" }}>{sub}</p>}
  </div>
);

const SubTabHeader = ({ count, label, action }) => (
  <div style={{
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "10px 16px",
    borderBottom: "1px solid rgba(255,255,255,0.05)",
    background: "rgba(255,255,255,0.02)",
  }}>
    <span style={{ fontSize: 12, color: "#64748b" }}>
      <strong style={{ color: "#94a3b8" }}>{count}</strong> {label}
    </span>
    {action}
  </div>
);

const LoadingSpinner = () => (
  <div style={{ textAlign: "center", padding: 40, color: "#64748b" }}>
    <i className="fa-solid fa-circle-notch fa-spin" style={{ fontSize: 22 }} />
    <p style={{ marginTop: 10, fontSize: 13 }}>Loading…</p>
  </div>
);

export default CallsPage;